import React, { useState } from "react";
import { Shell } from "lucide-react";

// Seashell rating — community ratings for resources (1–5).
// Active seashells render white on a teal background (no teal-on-teal "blob").
export function SeashellRating({ value = 0, onRate, readOnly = false, size = "h-5 w-5", showValue = false, count, testIdPrefix = "seashell" }) {
  const [hover, setHover] = useState(0);
  const active = hover || Math.round(value);
  return (
    <div className="flex items-center" data-testid={`${testIdPrefix}-rating`}>
      <div className="flex items-center gap-0.5">
        {[1, 2, 3, 4, 5].map((n) => (
          <button
            key={n}
            type="button"
            disabled={readOnly}
            onMouseEnter={() => !readOnly && setHover(n)}
            onMouseLeave={() => !readOnly && setHover(0)}
            onClick={() => !readOnly && onRate && onRate(n)}
            className={`transition-transform ${readOnly ? "cursor-default" : "cursor-pointer hover:scale-110"}`}
            aria-label={`${n} seashell${n > 1 ? "s" : ""}`}
            data-testid={`${testIdPrefix}-${n}`}
          >
            <Shell className={`${size} ${n <= active ? "text-primary" : "text-muted-foreground/40"}`} />
          </button>
        ))}
      </div>
      {showValue && (
        <span className="ml-2 text-sm text-muted-foreground">
          {value ? Number(value).toFixed(1) : "No ratings"}{count ? ` (${count})` : ""}
        </span>
      )}
    </div>
  );
}
